import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DateTime } from "luxon";

const Filter = ({ selectedDate, setSelectedDate, setRequestedServiceCategory, requestedServiceCategory }) => {
    const timeZone = 'America/Chicago';
    const currentPath = window.location.pathname; // Get current URL path
    console.log("requestedServiceCategory", requestedServiceCategory)
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: 20,
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: 280,
                    gap: "10px",
                }}
            >
                <h4>Filters</h4>
                <ul
                    style={{
                        display: "flex",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        gap: "8px",
                    }}
                >
                    {[
                        { id: 0, label: "All" },
                        { id: 1, label: "Appointment" },
                        { id: 2, label: "Class" },
                        { id: 4, label: "Event" },
                        { id: 3, label: 'Program'},
                        { id: 5, label: 'Contract'},
                        { id: 6, label: 'Package'}
                    ].map(({ id, label }) => (
                        <li key={id}>
                            <a
                                onClick={() => setRequestedServiceCategory(id)}
                                href="#"
                                style={{
                                    padding: "8px 12px",
                                    backgroundColor: requestedServiceCategory == id ? "#18636b" : "#04acbf",
                                    color: "#fff",
                                    textDecoration: "none",
                                    borderRadius: "5px",
                                    display: "inline-block",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    border: "none",
                                    cursor: "pointer",
                                    transition: "background 0.3s",
                                }}
                            >
                                {label}
                            </a>
                        </li>
                    ))}                    
                </ul>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: 280,
                }}
            >
                <i
                    className="fas fa-calendar-alt"
                    style={{
                        fontSize: "44px",
                        color: "#04acbf",
                        marginRight: 10,
                    }}
                ></i>

                <DatePicker
                    selected={selectedDate.toJSDate()}
                    onChange={(date) => setSelectedDate(DateTime.fromJSDate(date).setZone(timeZone))}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Choose a date"
                    className="form-control"
                />
            </div>
        </div>
    );
};

export default Filter;
